// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const WebexIcon = createSvgIcon(
  <svg width={24} height={24} fill="none" viewBox="0 0 24 24">
    <path
      fill="url(#webex_svga)"
      d="M6.57 12.25q.33 1.16.9 2.24c.18.31.35.63.66.82l.17.09c.46.08.71-.29.88-.6q.34-.8.6-1.64l.08-.32q.1-.3.15-.6l2.01-5.39a4.5 4.5 0 0 1 1.59-1.33q.91-.51 1.99-.51c1 0 1.98.34 2.78.96 1.33 1 2.1 2.98 2.1 2.98q.17.4.17.83-.01.37-.14.76a3 3 0 0 1-.43.66c-.17.17-.4.34-.65.42a2 2 0 0 1-.77.14q-.43.01-.82-.2a2 2 0 0 1-.68-.5q0-.02-.03-.03a4 4 0 0 1-.31-.57 6 6 0 0 0-.37-.71q-.1-.17-.23-.34a1 1 0 0 0-.25-.29c-.2-.14-.43-.2-.63-.08l-.03.03c-.22.14-.36.45-.48.7-.3.69-.48 1.37-.68 2.1l-.08.43-.86 2.73-1.16 2.58c-.43.54-.96 1-1.59 1.28q-.94.45-1.99.48c-2.86.06-4.2-2.52-4.2-2.52-1.62-2.67-2.1-6.2-2.21-7.33q-.08-.39-.06-.4c0-.34.08-.7.28-.99q.27-.47.74-.74.5-.24 1.05-.23a2 2 0 0 1 1.54.8c.25.37.34.85.36 1.3q.18 1.54.6 2.99"
    />
    <path
      fill="url(#webex_svgb)"
      d="M6.57 12.25q.33 1.16.9 2.24c.18.31.35.63.66.82l.17.09c.46.08.71-.29.88-.6q.34-.8.6-1.64l.08-.32q.1-.3.15-.6l2.01-5.39a4.5 4.5 0 0 1 1.59-1.33q.91-.51 1.99-.51c1 0 1.98.34 2.78.96 1.33 1 2.1 2.98 2.1 2.98q.17.4.17.83-.01.37-.14.76a3 3 0 0 1-.43.66c-.17.17-.4.34-.65.42a2 2 0 0 1-.77.14q-.43.01-.82-.2a2 2 0 0 1-.68-.5q0-.02-.03-.03a4 4 0 0 1-.31-.57 6 6 0 0 0-.37-.71q-.1-.17-.23-.34a1 1 0 0 0-.25-.29c-.2-.14-.43-.2-.63-.08l-.03.03c-.22.14-.36.45-.48.7-.3.69-.48 1.37-.68 2.1l-.08.43-.86 2.73-1.16 2.58c-.43.54-.96 1-1.59 1.28q-.94.45-1.99.48c-2.86.06-4.2-2.52-4.2-2.52-1.62-2.67-2.1-6.2-2.21-7.33q-.08-.39-.06-.4c0-.34.08-.7.28-.99q.27-.47.74-.74.5-.24 1.05-.23a2 2 0 0 1 1.54.8c.25.37.34.85.36 1.3q.18 1.54.6 2.99"
    />
    <path
      fill="url(#webex_svgc)"
      d="M6.57 12.25q.33 1.16.9 2.24c.18.31.35.63.66.82l.17.09c.46.08.71-.29.88-.6q.34-.8.6-1.64l.08-.32q.1-.3.15-.6l2.01-5.39a4.5 4.5 0 0 1 1.59-1.33q.91-.51 1.99-.51c1 0 1.98.34 2.78.96 1.33 1 2.1 2.98 2.1 2.98q.17.4.17.83-.01.37-.14.76a3 3 0 0 1-.43.66c-.17.17-.4.34-.65.42a2 2 0 0 1-.77.14q-.43.01-.82-.2a2 2 0 0 1-.68-.5q0-.02-.03-.03a4 4 0 0 1-.31-.57 6 6 0 0 0-.37-.71q-.1-.17-.23-.34a1 1 0 0 0-.25-.29c-.2-.14-.43-.2-.63-.08l-.03.03c-.22.14-.36.45-.48.7-.3.69-.48 1.37-.68 2.1l-.08.43-.86 2.73-1.16 2.58c-.43.54-.96 1-1.59 1.28q-.94.45-1.99.48c-2.86.06-4.2-2.52-4.2-2.52-1.62-2.67-2.1-6.2-2.21-7.33q-.08-.39-.06-.4c0-.34.08-.7.28-.99q.27-.47.74-.74.5-.24 1.05-.23a2 2 0 0 1 1.54.8c.25.37.34.85.36 1.3q.18 1.54.6 2.99"
    />
    <path
      fill="url(#webex_svgd)"
      d="M6.57 12.25q.33 1.16.9 2.24c.18.31.35.63.66.82l.17.09c.46.08.71-.29.88-.6q.34-.8.6-1.64l.08-.32q.1-.3.15-.6l2.01-5.39a4.5 4.5 0 0 1 1.59-1.33q.91-.51 1.99-.51c1 0 1.98.34 2.78.96 1.33 1 2.1 2.98 2.1 2.98q.17.4.17.83-.01.37-.14.76a3 3 0 0 1-.43.66c-.17.17-.4.34-.65.42a2 2 0 0 1-.77.14q-.43.01-.82-.2a2 2 0 0 1-.68-.5q0-.02-.03-.03a4 4 0 0 1-.31-.57 6 6 0 0 0-.37-.71q-.1-.17-.23-.34a1 1 0 0 0-.25-.29c-.2-.14-.43-.2-.63-.08l-.03.03c-.22.14-.36.45-.48.7-.3.69-.48 1.37-.68 2.1l-.08.43-.86 2.73-1.16 2.58c-.43.54-.96 1-1.59 1.28q-.94.45-1.99.48c-2.86.06-4.2-2.52-4.2-2.52-1.62-2.67-2.1-6.2-2.21-7.33q-.08-.39-.06-.4c0-.34.08-.7.28-.99q.27-.47.74-.74.5-.24 1.05-.23a2 2 0 0 1 1.54.8c.25.37.34.85.36 1.3q.18 1.54.6 2.99"
    />
    <path
      fill="url(#webex_svge)"
      d="M6.57 12.25q.33 1.16.9 2.24c.18.31.35.63.66.82l.17.09c.46.08.71-.29.88-.6q.34-.8.6-1.64l.08-.32q.1-.3.15-.6l2.01-5.39a4.5 4.5 0 0 1 1.59-1.33q.91-.51 1.99-.51c1 0 1.98.34 2.78.96 1.33 1 2.1 2.98 2.1 2.98q.17.4.17.83-.01.37-.14.76a3 3 0 0 1-.43.66c-.17.17-.4.34-.65.42a2 2 0 0 1-.77.14q-.43.01-.82-.2a2 2 0 0 1-.68-.5q0-.02-.03-.03a4 4 0 0 1-.31-.57 6 6 0 0 0-.37-.71q-.1-.17-.23-.34a1 1 0 0 0-.25-.29c-.2-.14-.43-.2-.63-.08l-.03.03c-.22.14-.36.45-.48.7-.3.69-.48 1.37-.68 2.1l-.08.43-.86 2.73-1.16 2.58c-.43.54-.96 1-1.59 1.28q-.94.45-1.99.48c-2.86.06-4.2-2.52-4.2-2.52-1.62-2.67-2.1-6.2-2.21-7.33q-.08-.39-.06-.4c0-.34.08-.7.28-.99q.27-.47.74-.74.5-.24 1.05-.23a2 2 0 0 1 1.54.8c.25.37.34.85.36 1.3q.18 1.54.6 2.99"
    />
    <path
      fill="url(#webex_svgf)"
      d="M6.57 12.25q.33 1.16.9 2.24c.18.31.35.63.66.82l.17.09c.46.08.71-.29.88-.6q.34-.8.6-1.64l.08-.32q.1-.3.15-.6l2.01-5.39a4.5 4.5 0 0 1 1.59-1.33q.91-.51 1.99-.51c1 0 1.98.34 2.78.96 1.33 1 2.1 2.98 2.1 2.98q.17.4.17.83-.01.37-.14.76a3 3 0 0 1-.43.66c-.17.17-.4.34-.65.42a2 2 0 0 1-.77.14q-.43.01-.82-.2a2 2 0 0 1-.68-.5q0-.02-.03-.03a4 4 0 0 1-.31-.57 6 6 0 0 0-.37-.71q-.1-.17-.23-.34a1 1 0 0 0-.25-.29c-.2-.14-.43-.2-.63-.08l-.03.03c-.22.14-.36.45-.48.7-.3.69-.48 1.37-.68 2.1l-.08.43-.86 2.73-1.16 2.58c-.43.54-.96 1-1.59 1.28q-.94.45-1.99.48c-2.86.06-4.2-2.52-4.2-2.52-1.62-2.67-2.1-6.2-2.21-7.33q-.08-.39-.06-.4c0-.34.08-.7.28-.99q.27-.47.74-.74.5-.24 1.05-.23a2 2 0 0 1 1.54.8c.25.37.34.85.36 1.3q.18 1.54.6 2.99"
    />
    <path
      fill="url(#webex_svgg)"
      d="M6.57 12.25q.33 1.16.9 2.24c.18.31.35.63.66.82l.17.09c.46.08.71-.29.88-.6q.34-.8.6-1.64l.08-.32q.1-.3.15-.6l2.01-5.39a4.5 4.5 0 0 1 1.59-1.33q.91-.51 1.99-.51c1 0 1.98.34 2.78.96 1.33 1 2.1 2.98 2.1 2.98q.17.4.17.83-.01.37-.14.76a3 3 0 0 1-.43.66c-.17.17-.4.34-.65.42a2 2 0 0 1-.77.14q-.43.01-.82-.2a2 2 0 0 1-.68-.5q0-.02-.03-.03a4 4 0 0 1-.31-.57 6 6 0 0 0-.37-.71q-.1-.17-.23-.34a1 1 0 0 0-.25-.29c-.2-.14-.43-.2-.63-.08l-.03.03c-.22.14-.36.45-.48.7-.3.69-.48 1.37-.68 2.1l-.08.43-.86 2.73-1.16 2.58c-.43.54-.96 1-1.59 1.28q-.94.45-1.99.48c-2.86.06-4.2-2.52-4.2-2.52-1.62-2.67-2.1-6.2-2.21-7.33q-.08-.39-.06-.4c0-.34.08-.7.28-.99q.27-.47.74-.74.5-.24 1.05-.23a2 2 0 0 1 1.54.8c.25.37.34.85.36 1.3q.18 1.54.6 2.99"
    />
    <path
      fill="url(#webex_svgh)"
      d="M6.57 12.25q.33 1.16.9 2.24c.18.31.35.63.66.82l.17.09c.46.08.71-.29.88-.6q.34-.8.6-1.64l.08-.32q.1-.3.15-.6l2.01-5.39a4.5 4.5 0 0 1 1.59-1.33q.91-.51 1.99-.51c1 0 1.98.34 2.78.96 1.33 1 2.1 2.98 2.1 2.98q.17.4.17.83-.01.37-.14.76a3 3 0 0 1-.43.66c-.17.17-.4.34-.65.42a2 2 0 0 1-.77.14q-.43.01-.82-.2a2 2 0 0 1-.68-.5q0-.02-.03-.03a4 4 0 0 1-.31-.57 6 6 0 0 0-.37-.71q-.1-.17-.23-.34a1 1 0 0 0-.25-.29c-.2-.14-.43-.2-.63-.08l-.03.03c-.22.14-.36.45-.48.7-.3.69-.48 1.37-.68 2.1l-.08.43-.86 2.73-1.16 2.58c-.43.54-.96 1-1.59 1.28q-.94.45-1.99.48c-2.86.06-4.2-2.52-4.2-2.52-1.62-2.67-2.1-6.2-2.21-7.33q-.08-.39-.06-.4c0-.34.08-.7.28-.99q.27-.47.74-.74.5-.24 1.05-.23a2 2 0 0 1 1.54.8c.25.37.34.85.36 1.3q.18 1.54.6 2.99"
    />
    <path
      fill="url(#webex_svgi)"
      d="M6.57 12.25q.33 1.16.9 2.24c.18.31.35.63.66.82l.17.09c.46.08.71-.29.88-.6q.34-.8.6-1.64l.08-.32q.1-.3.15-.6l2.01-5.39a4.5 4.5 0 0 1 1.59-1.33q.91-.51 1.99-.51c1 0 1.98.34 2.78.96 1.33 1 2.1 2.98 2.1 2.98q.17.4.17.83-.01.37-.14.76a3 3 0 0 1-.43.66c-.17.17-.4.34-.65.42a2 2 0 0 1-.77.14q-.43.01-.82-.2a2 2 0 0 1-.68-.5q0-.02-.03-.03a4 4 0 0 1-.31-.57 6 6 0 0 0-.37-.71q-.1-.17-.23-.34a1 1 0 0 0-.25-.29c-.2-.14-.43-.2-.63-.08l-.03.03c-.22.14-.36.45-.48.7-.3.69-.48 1.37-.68 2.1l-.08.43-.86 2.73-1.16 2.58c-.43.54-.96 1-1.59 1.28q-.94.45-1.99.48c-2.86.06-4.2-2.52-4.2-2.52-1.62-2.67-2.1-6.2-2.21-7.33q-.08-.39-.06-.4c0-.34.08-.7.28-.99q.27-.47.74-.74.5-.24 1.05-.23a2 2 0 0 1 1.54.8c.25.37.34.85.36 1.3q.18 1.54.6 2.99"
    />
    <path
      fill="url(#webex_svgj)"
      d="M6.57 12.25q.33 1.16.9 2.24c.18.31.35.63.66.82l.17.09c.46.08.71-.29.88-.6q.34-.8.6-1.64l.08-.32q.1-.3.15-.6l2.01-5.39a4.5 4.5 0 0 1 1.59-1.33q.91-.51 1.99-.51c1 0 1.98.34 2.78.96 1.33 1 2.1 2.98 2.1 2.98q.17.4.17.83-.01.37-.14.76a3 3 0 0 1-.43.66c-.17.17-.4.34-.65.42a2 2 0 0 1-.77.14q-.43.01-.82-.2a2 2 0 0 1-.68-.5q0-.02-.03-.03a4 4 0 0 1-.31-.57 6 6 0 0 0-.37-.71q-.1-.17-.23-.34a1 1 0 0 0-.25-.29c-.2-.14-.43-.2-.63-.08l-.03.03c-.22.14-.36.45-.48.7-.3.69-.48 1.37-.68 2.1l-.08.43-.86 2.73-1.16 2.58c-.43.54-.96 1-1.59 1.28q-.94.45-1.99.48c-2.86.06-4.2-2.52-4.2-2.52-1.62-2.67-2.1-6.2-2.21-7.33q-.08-.39-.06-.4c0-.34.08-.7.28-.99q.27-.47.74-.74.5-.24 1.05-.23a2 2 0 0 1 1.54.8c.25.37.34.85.36 1.3q.18 1.54.6 2.99"
    />
    <path
      fill="url(#webex_svgk)"
      d="M6.57 12.25q.33 1.16.9 2.24c.18.31.35.63.66.82l.17.09c.46.08.71-.29.88-.6q.34-.8.6-1.64l.08-.32q.1-.3.15-.6l2.01-5.39a4.5 4.5 0 0 1 1.59-1.33q.91-.51 1.99-.51c1 0 1.98.34 2.78.96 1.33 1 2.1 2.98 2.1 2.98q.17.4.17.83-.01.37-.14.76a3 3 0 0 1-.43.66c-.17.17-.4.34-.65.42a2 2 0 0 1-.77.14q-.43.01-.82-.2a2 2 0 0 1-.68-.5q0-.02-.03-.03a4 4 0 0 1-.31-.57 6 6 0 0 0-.37-.71q-.1-.17-.23-.34a1 1 0 0 0-.25-.29c-.2-.14-.43-.2-.63-.08l-.03.03c-.22.14-.36.45-.48.7-.3.69-.48 1.37-.68 2.1l-.08.43-.86 2.73-1.16 2.58c-.43.54-.96 1-1.59 1.28q-.94.45-1.99.48c-2.86.06-4.2-2.52-4.2-2.52-1.62-2.67-2.1-6.2-2.21-7.33q-.08-.39-.06-.4c0-.34.08-.7.28-.99q.27-.47.74-.74.5-.24 1.05-.23a2 2 0 0 1 1.54.8c.25.37.34.85.36 1.3q.18 1.54.6 2.99"
    />
    <path
      fill="url(#webex_svgl)"
      d="M6.57 12.25q.33 1.16.9 2.24c.18.31.35.63.66.82l.17.09c.46.08.71-.29.88-.6q.34-.8.6-1.64l.08-.32q.1-.3.15-.6l2.01-5.39a4.5 4.5 0 0 1 1.59-1.33q.91-.51 1.99-.51c1 0 1.98.34 2.78.96 1.33 1 2.1 2.98 2.1 2.98q.17.4.17.83-.01.37-.14.76a3 3 0 0 1-.43.66c-.17.17-.4.34-.65.42a2 2 0 0 1-.77.14q-.43.01-.82-.2a2 2 0 0 1-.68-.5q0-.02-.03-.03a4 4 0 0 1-.31-.57 6 6 0 0 0-.37-.71q-.1-.17-.23-.34a1 1 0 0 0-.25-.29c-.2-.14-.43-.2-.63-.08l-.03.03c-.22.14-.36.45-.48.7-.3.69-.48 1.37-.68 2.1l-.08.43-.86 2.73-1.16 2.58c-.43.54-.96 1-1.59 1.28q-.94.45-1.99.48c-2.86.06-4.2-2.52-4.2-2.52-1.62-2.67-2.1-6.2-2.21-7.33q-.08-.39-.06-.4c0-.34.08-.7.28-.99q.27-.47.74-.74.5-.24 1.05-.23a2 2 0 0 1 1.54.8c.25.37.34.85.36 1.3q.18 1.54.6 2.99"
    />
    <path
      fill="url(#webex_svgm)"
      d="M6.57 12.25q.33 1.16.9 2.24c.18.31.35.63.66.82l.17.09c.46.08.71-.29.88-.6q.34-.8.6-1.64l.08-.32q.1-.3.15-.6l2.01-5.39a4.5 4.5 0 0 1 1.59-1.33q.91-.51 1.99-.51c1 0 1.98.34 2.78.96 1.33 1 2.1 2.98 2.1 2.98q.17.4.17.83-.01.37-.14.76a3 3 0 0 1-.43.66c-.17.17-.4.34-.65.42a2 2 0 0 1-.77.14q-.43.01-.82-.2a2 2 0 0 1-.68-.5q0-.02-.03-.03a4 4 0 0 1-.31-.57 6 6 0 0 0-.37-.71q-.1-.17-.23-.34a1 1 0 0 0-.25-.29c-.2-.14-.43-.2-.63-.08l-.03.03c-.22.14-.36.45-.48.7-.3.69-.48 1.37-.68 2.1l-.08.43-.86 2.73-1.16 2.58c-.43.54-.96 1-1.59 1.28q-.94.45-1.99.48c-2.86.06-4.2-2.52-4.2-2.52-1.62-2.67-2.1-6.2-2.21-7.33q-.08-.39-.06-.4c0-.34.08-.7.28-.99q.27-.47.74-.74.5-.24 1.05-.23a2 2 0 0 1 1.54.8c.25.37.34.85.36 1.3q.18 1.54.6 2.99"
    />
    <path
      fill="url(#webex_svgn)"
      d="M6.57 12.25q.33 1.16.9 2.24c.18.31.35.63.66.82l.17.09c.46.08.71-.29.88-.6q.34-.8.6-1.64l.08-.32q.1-.3.15-.6l2.01-5.39a4.5 4.5 0 0 1 1.59-1.33q.91-.51 1.99-.51c1 0 1.98.34 2.78.96 1.33 1 2.1 2.98 2.1 2.98q.17.4.17.83-.01.37-.14.76a3 3 0 0 1-.43.66c-.17.17-.4.34-.65.42a2 2 0 0 1-.77.14q-.43.01-.82-.2a2 2 0 0 1-.68-.5q0-.02-.03-.03a4 4 0 0 1-.31-.57 6 6 0 0 0-.37-.71q-.1-.17-.23-.34a1 1 0 0 0-.25-.29c-.2-.14-.43-.2-.63-.08l-.03.03c-.22.14-.36.45-.48.7-.3.69-.48 1.37-.68 2.1l-.08.43-.86 2.73-1.16 2.58c-.43.54-.96 1-1.59 1.28q-.94.45-1.99.48c-2.86.06-4.2-2.52-4.2-2.52-1.62-2.67-2.1-6.2-2.21-7.33q-.08-.39-.06-.4c0-.34.08-.7.28-.99q.27-.47.74-.74.5-.24 1.05-.23a2 2 0 0 1 1.54.8c.25.37.34.85.36 1.3q.18 1.54.6 2.99"
    />
    <path
      fill="url(#webex_svgo)"
      d="M6.57 12.25q.33 1.16.9 2.24c.18.31.35.63.66.82l.17.09c.46.08.71-.29.88-.6q.34-.8.6-1.64l.08-.32q.1-.3.15-.6l2.01-5.39a4.5 4.5 0 0 1 1.59-1.33q.91-.51 1.99-.51c1 0 1.98.34 2.78.96 1.33 1 2.1 2.98 2.1 2.98q.17.4.17.83-.01.37-.14.76a3 3 0 0 1-.43.66c-.17.17-.4.34-.65.42a2 2 0 0 1-.77.14q-.43.01-.82-.2a2 2 0 0 1-.68-.5q0-.02-.03-.03a4 4 0 0 1-.31-.57 6 6 0 0 0-.37-.71q-.1-.17-.23-.34a1 1 0 0 0-.25-.29c-.2-.14-.43-.2-.63-.08l-.03.03c-.22.14-.36.45-.48.7-.3.69-.48 1.37-.68 2.1l-.08.43-.86 2.73-1.16 2.58c-.43.54-.96 1-1.59 1.28q-.94.45-1.99.48c-2.86.06-4.2-2.52-4.2-2.52-1.62-2.67-2.1-6.2-2.21-7.33q-.08-.39-.06-.4c0-.34.08-.7.28-.99q.27-.47.74-.74.5-.24 1.05-.23a2 2 0 0 1 1.54.8c.25.37.34.85.36 1.3q.18 1.54.6 2.99"
    />
    <path
      fill="url(#webex_svgp)"
      d="M6.57 12.25q.33 1.16.9 2.24c.18.31.35.63.66.82l.17.09c.46.08.71-.29.88-.6q.34-.8.6-1.64l.08-.32q.1-.3.15-.6l2.01-5.39a4.5 4.5 0 0 1 1.59-1.33q.91-.51 1.99-.51c1 0 1.98.34 2.78.96 1.33 1 2.1 2.98 2.1 2.98q.17.4.17.83-.01.37-.14.76a3 3 0 0 1-.43.66c-.17.17-.4.34-.65.42a2 2 0 0 1-.77.14q-.43.01-.82-.2a2 2 0 0 1-.68-.5q0-.02-.03-.03a4 4 0 0 1-.31-.57 6 6 0 0 0-.37-.71q-.1-.17-.23-.34a1 1 0 0 0-.25-.29c-.2-.14-.43-.2-.63-.08l-.03.03c-.22.14-.36.45-.48.7-.3.69-.48 1.37-.68 2.1l-.08.43-.86 2.73-1.16 2.58c-.43.54-.96 1-1.59 1.28q-.94.45-1.99.48c-2.86.06-4.2-2.52-4.2-2.52-1.62-2.67-2.1-6.2-2.21-7.33q-.08-.39-.06-.4c0-.34.08-.7.28-.99q.27-.47.74-.74.5-.24 1.05-.23a2 2 0 0 1 1.54.8c.25.37.34.85.36 1.3q.18 1.54.6 2.99"
    />
    <path
      fill="url(#webex_svgq)"
      d="M6.57 12.25q.33 1.16.9 2.24c.18.31.35.63.66.82l.17.09c.46.08.71-.29.88-.6q.34-.8.6-1.64l.08-.32q.1-.3.15-.6l2.01-5.39a4.5 4.5 0 0 1 1.59-1.33q.91-.51 1.99-.51c1 0 1.98.34 2.78.96 1.33 1 2.1 2.98 2.1 2.98q.17.4.17.83-.01.37-.14.76a3 3 0 0 1-.43.66c-.17.17-.4.34-.65.42a2 2 0 0 1-.77.14q-.43.01-.82-.2a2 2 0 0 1-.68-.5q0-.02-.03-.03a4 4 0 0 1-.31-.57 6 6 0 0 0-.37-.71q-.1-.17-.23-.34a1 1 0 0 0-.25-.29c-.2-.14-.43-.2-.63-.08l-.03.03c-.22.14-.36.45-.48.7-.3.69-.48 1.37-.68 2.1l-.08.43-.86 2.73-1.16 2.58c-.43.54-.96 1-1.59 1.28q-.94.45-1.99.48c-2.86.06-4.2-2.52-4.2-2.52-1.62-2.67-2.1-6.2-2.21-7.33q-.08-.39-.06-.4c0-.34.08-.7.28-.99q.27-.47.74-.74.5-.24 1.05-.23a2 2 0 0 1 1.54.8c.25.37.34.85.36 1.3q.18 1.54.6 2.99"
    />
    <path
      fill="url(#webex_svgr)"
      d="M6.57 12.25q.33 1.16.9 2.24c.18.31.35.63.66.82l.17.09c.46.08.71-.29.88-.6q.34-.8.6-1.64l.08-.32q.1-.3.15-.6l2.01-5.39a4.5 4.5 0 0 1 1.59-1.33q.91-.51 1.99-.51c1 0 1.98.34 2.78.96 1.33 1 2.1 2.98 2.1 2.98q.17.4.17.83-.01.37-.14.76a3 3 0 0 1-.43.66c-.17.17-.4.34-.65.42a2 2 0 0 1-.77.14q-.43.01-.82-.2a2 2 0 0 1-.68-.5q0-.02-.03-.03a4 4 0 0 1-.31-.57 6 6 0 0 0-.37-.71q-.1-.17-.23-.34a1 1 0 0 0-.25-.29c-.2-.14-.43-.2-.63-.08l-.03.03c-.22.14-.36.45-.48.7-.3.69-.48 1.37-.68 2.1l-.08.43-.86 2.73-1.16 2.58c-.43.54-.96 1-1.59 1.28q-.94.45-1.99.48c-2.86.06-4.2-2.52-4.2-2.52-1.62-2.67-2.1-6.2-2.21-7.33q-.08-.39-.06-.4c0-.34.08-.7.28-.99q.27-.47.74-.74.5-.24 1.05-.23a2 2 0 0 1 1.54.8c.25.37.34.85.36 1.3q.18 1.54.6 2.99"
    />
    <path
      fill="url(#webex_svgs)"
      d="M6.57 12.25q.33 1.16.9 2.24c.18.31.35.63.66.82l.17.09c.46.08.71-.29.88-.6q.34-.8.6-1.64l.08-.32q.1-.3.15-.6l2.01-5.39a4.5 4.5 0 0 1 1.59-1.33q.91-.51 1.99-.51c1 0 1.98.34 2.78.96 1.33 1 2.1 2.98 2.1 2.98q.17.4.17.83-.01.37-.14.76a3 3 0 0 1-.43.66c-.17.17-.4.34-.65.42a2 2 0 0 1-.77.14q-.43.01-.82-.2a2 2 0 0 1-.68-.5q0-.02-.03-.03a4 4 0 0 1-.31-.57 6 6 0 0 0-.37-.71q-.1-.17-.23-.34a1 1 0 0 0-.25-.29c-.2-.14-.43-.2-.63-.08l-.03.03c-.22.14-.36.45-.48.7-.3.69-.48 1.37-.68 2.1l-.08.43-.86 2.73-1.16 2.58c-.43.54-.96 1-1.59 1.28q-.94.45-1.99.48c-2.86.06-4.2-2.52-4.2-2.52-1.62-2.67-2.1-6.2-2.21-7.33q-.08-.39-.06-.4c0-.34.08-.7.28-.99q.27-.47.74-.74.5-.24 1.05-.23a2 2 0 0 1 1.54.8c.25.37.34.85.36 1.3q.18 1.54.6 2.99"
    />
    <path
      fill="url(#webex_svgt)"
      d="M6.57 12.25q.33 1.16.9 2.24c.18.31.35.63.66.82l.17.09c.46.08.71-.29.88-.6q.34-.8.6-1.64l.08-.32q.1-.3.15-.6l2.01-5.39a4.5 4.5 0 0 1 1.59-1.33q.91-.51 1.99-.51c1 0 1.98.34 2.78.96 1.33 1 2.1 2.98 2.1 2.98q.17.4.17.83-.01.37-.14.76a3 3 0 0 1-.43.66c-.17.17-.4.34-.65.42a2 2 0 0 1-.77.14q-.43.01-.82-.2a2 2 0 0 1-.68-.5q0-.02-.03-.03a4 4 0 0 1-.31-.57 6 6 0 0 0-.37-.71q-.1-.17-.23-.34a1 1 0 0 0-.25-.29c-.2-.14-.43-.2-.63-.08l-.03.03c-.22.14-.36.45-.48.7-.3.69-.48 1.37-.68 2.1l-.08.43-.86 2.73-1.16 2.58c-.43.54-.96 1-1.59 1.28q-.94.45-1.99.48c-2.86.06-4.2-2.52-4.2-2.52-1.62-2.67-2.1-6.2-2.21-7.33q-.08-.39-.06-.4c0-.34.08-.7.28-.99q.27-.47.74-.74.5-.24 1.05-.23a2 2 0 0 1 1.54.8c.25.37.34.85.36 1.3q.18 1.54.6 2.99"
    />
    <path
      fill="url(#webex_svgu)"
      d="m10.72 10.23 1.27-3.43a4.5 4.5 0 0 1 1.6-1.34q.94-.44 2-.45c1 0 2 .34 2.79.96 1.33 1 2.1 2.98 2.1 2.98q.17.4.17.83-.01.37-.14.76a3 3 0 0 1-.43.66c-.17.17-.4.34-.65.42a2 2 0 0 1-.77.14q-.42.01-.82-.2a2 2 0 0 1-.68-.5q0-.02-.03-.03a4 4 0 0 1-.31-.57 6 6 0 0 0-.37-.71q-.1-.17-.23-.34a1 1 0 0 0-.25-.29c-.2-.14-.43-.2-.63-.08l-.02.03c-.23.14-.37.45-.49.7-.3.69-.48 1.37-.68 2.1l-.08.43-.86 2.73z"
    />
    <path
      fill="url(#webex_svgv)"
      d="M20.03 7.17q-.26.01-.49.05.56.81.94 1.7.18.4.17.83 0 .39-.14.77a3 3 0 0 1-.43.65q-.27.3-.65.43a2 2 0 0 1-.76.14q-.55 0-1-.29l-.2.77c-.37 1.25-.62 1.7-.62 1.7q-.21.5-.51.97c-.14.2-.31.4-.54.48q-.13.04-.26.03a.5.5 0 0 1-.25-.09 1.4 1.4 0 0 1-.37-.45q-.16-.3-.28-.6c-.18-.42-.46-1.47-.46-1.47l-.28-1.11-.29-1.1-.2-.75A9 9 0 0 0 12.17 7a4.8 4.8 0 0 0-2.33-1.76c-1.08-.4-2.22-.18-2.22-.18A4.8 4.8 0 0 0 4.5 7.22q.3.08.54.23.35.21.57.51c.25.37.34.85.37 1.3q.17 1.49.56 2.93c.6-2.01 1.34-2.95 1.34-2.95a1 1 0 0 1 .28-.26q.09-.04.2-.05c.12 0 .26.02.34.08q.03.01.06.03.13.12.25.28c.15.29.29.54.4.86.23.62.43 1.41.43 1.41l.57 2.28c.42 1.56.76 2.3.76 2.3.88 2.01 2.22 2.58 2.22 2.58.65.34 1.39.54 2.13.57.7.02 1.41-.12 2.04-.43a5.5 5.5 0 0 0 2.58-2.72q.8-1.59 1.22-3.3.3-1.05.46-2.16.1-.53.14-1.07.1-.51-.03-1.03-.03-.07-.05-.17a2 2 0 0 0-.88-.99q-.45-.29-.97-.28"
    />
    <path
      fill="url(#webex_svgw)"
      d="M20.03 7.17q-.26.01-.49.05.56.81.94 1.7.18.4.17.83 0 .39-.14.77a3 3 0 0 1-.43.65q-.27.3-.65.43a2 2 0 0 1-.76.14q-.55 0-1-.29l-.2.77c-.37 1.25-.62 1.7-.62 1.7q-.21.5-.51.97c-.14.2-.31.4-.54.48q-.13.04-.26.03a.5.5 0 0 1-.25-.09 1.4 1.4 0 0 1-.37-.45q-.16-.3-.28-.6c-.18-.42-.46-1.47-.46-1.47l-.28-1.11-.29-1.1-.2-.75A9 9 0 0 0 12.17 7a4.8 4.8 0 0 0-2.33-1.76c-1.08-.4-2.22-.18-2.22-.18A4.8 4.8 0 0 0 4.5 7.22q.3.08.54.23.35.21.57.51c.25.37.34.85.37 1.3q.17 1.49.56 2.93c.6-2.01 1.34-2.95 1.34-2.95a1 1 0 0 1 .28-.26q.09-.04.2-.05c.12 0 .26.02.34.08q.03.01.06.03.13.12.25.28c.15.29.29.54.4.86.23.62.43 1.41.43 1.41l.57 2.28c.42 1.56.76 2.3.76 2.3.88 2.01 2.22 2.58 2.22 2.58.65.34 1.39.54 2.13.57.7.02 1.41-.12 2.04-.43a5.5 5.5 0 0 0 2.58-2.72q.8-1.59 1.22-3.3.3-1.05.46-2.16.1-.53.14-1.07.1-.51-.03-1.03-.03-.07-.05-.17a2 2 0 0 0-.88-.99q-.45-.29-.97-.28"
    />
    <path
      fill="url(#webex_svgx)"
      d="M20.03 7.17q-.26.01-.49.05.56.81.94 1.7.18.4.17.83 0 .39-.14.77a3 3 0 0 1-.43.65q-.27.3-.65.43a2 2 0 0 1-.76.14q-.55 0-1-.29l-.2.77c-.37 1.25-.62 1.7-.62 1.7q-.21.5-.51.97c-.14.2-.31.4-.54.48q-.13.04-.26.03a.5.5 0 0 1-.25-.09 1.4 1.4 0 0 1-.37-.45q-.16-.3-.28-.6c-.18-.42-.46-1.47-.46-1.47l-.28-1.11-.29-1.1-.2-.75A9 9 0 0 0 12.17 7a4.8 4.8 0 0 0-2.33-1.76c-1.08-.4-2.22-.18-2.22-.18A4.8 4.8 0 0 0 4.5 7.22q.3.08.54.23.35.21.57.51c.25.37.34.85.37 1.3q.17 1.49.56 2.93c.6-2.01 1.34-2.95 1.34-2.95a1 1 0 0 1 .28-.26q.09-.04.2-.05c.12 0 .26.02.34.08q.03.01.06.03.13.12.25.28c.15.29.29.54.4.86.23.62.43 1.41.43 1.41l.57 2.28c.42 1.56.76 2.3.76 2.3.88 2.01 2.22 2.58 2.22 2.58.65.34 1.39.54 2.13.57.7.02 1.41-.12 2.04-.43a5.5 5.5 0 0 0 2.58-2.72q.8-1.59 1.22-3.3.3-1.05.46-2.16.1-.53.14-1.07.1-.51-.03-1.03-.03-.07-.05-.17a2 2 0 0 0-.88-.99q-.45-.29-.97-.28"
    />
    <path
      fill="url(#webex_svgy)"
      d="M20.03 7.17q-.26.01-.49.05.56.81.94 1.7.18.4.17.83 0 .39-.14.77a3 3 0 0 1-.43.65q-.27.3-.65.43a2 2 0 0 1-.76.14q-.55 0-1-.29l-.2.77c-.37 1.25-.62 1.7-.62 1.7q-.21.5-.51.97c-.14.2-.31.4-.54.48q-.13.04-.26.03a.5.5 0 0 1-.25-.09 1.4 1.4 0 0 1-.37-.45q-.16-.3-.28-.6c-.18-.42-.46-1.47-.46-1.47l-.28-1.11-.29-1.1-.2-.75A9 9 0 0 0 12.17 7a4.8 4.8 0 0 0-2.33-1.76c-1.08-.4-2.22-.18-2.22-.18A4.8 4.8 0 0 0 4.5 7.22q.3.08.54.23.35.21.57.51c.25.37.34.85.37 1.3q.17 1.49.56 2.93c.6-2.01 1.34-2.95 1.34-2.95a1 1 0 0 1 .28-.26q.09-.04.2-.05c.12 0 .26.02.34.08q.03.01.06.03.13.12.25.28c.15.29.29.54.4.86.23.62.43 1.41.43 1.41l.57 2.28c.42 1.56.76 2.3.76 2.3.88 2.01 2.22 2.58 2.22 2.58.65.34 1.39.54 2.13.57.7.02 1.41-.12 2.04-.43a5.5 5.5 0 0 0 2.58-2.72q.8-1.59 1.22-3.3.3-1.05.46-2.16.1-.53.14-1.07.1-.51-.03-1.03-.03-.07-.05-.17a2 2 0 0 0-.88-.99q-.45-.29-.97-.28"
    />
    <path
      fill="url(#webex_svgz)"
      d="M20.03 7.17q-.26.01-.49.05.56.81.94 1.7.18.4.17.83 0 .39-.14.77a3 3 0 0 1-.43.65q-.27.3-.65.43a2 2 0 0 1-.76.14q-.55 0-1-.29l-.2.77c-.37 1.25-.62 1.7-.62 1.7q-.21.5-.51.97c-.14.2-.31.4-.54.48q-.13.04-.26.03a.5.5 0 0 1-.25-.09 1.4 1.4 0 0 1-.37-.45q-.16-.3-.28-.6c-.18-.42-.46-1.47-.46-1.47l-.28-1.11-.29-1.1-.2-.75A9 9 0 0 0 12.17 7a4.8 4.8 0 0 0-2.33-1.76c-1.08-.4-2.22-.18-2.22-.18A4.8 4.8 0 0 0 4.5 7.22q.3.08.54.23.35.21.57.51c.25.37.34.85.37 1.3q.17 1.49.56 2.93c.6-2.01 1.34-2.95 1.34-2.95a1 1 0 0 1 .28-.26q.09-.04.2-.05c.12 0 .26.02.34.08q.03.01.06.03.13.12.25.28c.15.29.29.54.4.86.23.62.43 1.41.43 1.41l.57 2.28c.42 1.56.76 2.3.76 2.3.88 2.01 2.22 2.58 2.22 2.58.65.34 1.39.54 2.13.57.7.02 1.41-.12 2.04-.43a5.5 5.5 0 0 0 2.58-2.72q.8-1.59 1.22-3.3.3-1.05.46-2.16.1-.53.14-1.07.1-.51-.03-1.03-.03-.07-.05-.17a2 2 0 0 0-.88-.99q-.45-.29-.97-.28"
    />
    <path
      fill="url(#webex_svgA)"
      d="M20.03 7.17q-.26.01-.49.05.56.81.94 1.7.18.4.17.83 0 .39-.14.77a3 3 0 0 1-.43.65q-.27.3-.65.43a2 2 0 0 1-.76.14q-.55 0-1-.29l-.2.77c-.37 1.25-.62 1.7-.62 1.7q-.21.5-.51.97c-.14.2-.31.4-.54.48q-.13.04-.26.03a.5.5 0 0 1-.25-.09 1.4 1.4 0 0 1-.37-.45q-.16-.3-.28-.6c-.18-.42-.46-1.47-.46-1.47l-.28-1.11-.29-1.1-.2-.75A9 9 0 0 0 12.17 7a4.8 4.8 0 0 0-2.33-1.76c-1.08-.4-2.22-.18-2.22-.18A4.8 4.8 0 0 0 4.5 7.22q.3.08.54.23.35.21.57.51c.25.37.34.85.37 1.3q.17 1.49.56 2.93c.6-2.01 1.34-2.95 1.34-2.95a1 1 0 0 1 .28-.26q.09-.04.2-.05c.12 0 .26.02.34.08q.03.01.06.03.13.12.25.28c.15.29.29.54.4.86.23.62.43 1.41.43 1.41l.57 2.28c.42 1.56.76 2.3.76 2.3.88 2.01 2.22 2.58 2.22 2.58.65.34 1.39.54 2.13.57.7.02 1.41-.12 2.04-.43a5.5 5.5 0 0 0 2.58-2.72q.8-1.59 1.22-3.3.3-1.05.46-2.16.1-.53.14-1.07.1-.51-.03-1.03-.03-.07-.05-.17a2 2 0 0 0-.88-.99q-.45-.29-.97-.28"
    />
    <path
      fill="url(#webex_svgB)"
      d="M20.03 7.17q-.26.01-.49.05.56.81.94 1.7.18.4.17.83 0 .39-.14.77a3 3 0 0 1-.43.65q-.27.3-.65.43a2 2 0 0 1-.76.14q-.55 0-1-.29l-.2.77c-.37 1.25-.62 1.7-.62 1.7q-.21.5-.51.97c-.14.2-.31.4-.54.48q-.13.04-.26.03a.5.5 0 0 1-.25-.09 1.4 1.4 0 0 1-.37-.45q-.16-.3-.28-.6c-.18-.42-.46-1.47-.46-1.47l-.28-1.11-.29-1.1-.2-.75A9 9 0 0 0 12.17 7a4.8 4.8 0 0 0-2.33-1.76c-1.08-.4-2.22-.18-2.22-.18A4.8 4.8 0 0 0 4.5 7.22q.3.08.54.23.35.21.57.51c.25.37.34.85.37 1.3q.17 1.49.56 2.93c.6-2.01 1.34-2.95 1.34-2.95a1 1 0 0 1 .28-.26q.09-.04.2-.05c.12 0 .26.02.34.08q.03.01.06.03.13.12.25.28c.15.29.29.54.4.86.23.62.43 1.41.43 1.41l.57 2.28c.42 1.56.76 2.3.76 2.3.88 2.01 2.22 2.58 2.22 2.58.65.34 1.39.54 2.13.57.7.02 1.41-.12 2.04-.43a5.5 5.5 0 0 0 2.58-2.72q.8-1.59 1.22-3.3.3-1.05.46-2.16.1-.53.14-1.07.1-.51-.03-1.03-.03-.07-.05-.17a2 2 0 0 0-.88-.99q-.45-.29-.97-.28"
    />
    <path
      fill="url(#webex_svgC)"
      d="M20.03 7.17q-.26.01-.49.05.56.81.94 1.7.18.4.17.83 0 .39-.14.77a3 3 0 0 1-.43.65q-.27.3-.65.43a2 2 0 0 1-.76.14q-.55 0-1-.29l-.2.77c-.37 1.25-.62 1.7-.62 1.7q-.21.5-.51.97c-.14.2-.31.4-.54.48q-.13.04-.26.03a.5.5 0 0 1-.25-.09 1.4 1.4 0 0 1-.37-.45q-.16-.3-.28-.6c-.18-.42-.46-1.47-.46-1.47l-.28-1.11-.29-1.1-.2-.75A9 9 0 0 0 12.17 7a4.8 4.8 0 0 0-2.33-1.76c-1.08-.4-2.22-.18-2.22-.18A4.8 4.8 0 0 0 4.5 7.22q.3.08.54.23.35.21.57.51c.25.37.34.85.37 1.3q.17 1.49.56 2.93c.6-2.01 1.34-2.95 1.34-2.95a1 1 0 0 1 .28-.26q.09-.04.2-.05c.12 0 .26.02.34.08q.03.01.06.03.13.12.25.28c.15.29.29.54.4.86.23.62.43 1.41.43 1.41l.57 2.28c.42 1.56.76 2.3.76 2.3.88 2.01 2.22 2.58 2.22 2.58.65.34 1.39.54 2.13.57.7.02 1.41-.12 2.04-.43a5.5 5.5 0 0 0 2.58-2.72q.8-1.59 1.22-3.3.3-1.05.46-2.16.1-.53.14-1.07.1-.51-.03-1.03-.03-.07-.05-.17a2 2 0 0 0-.88-.99q-.45-.29-.97-.28"
    />
    <path
      fill="url(#webex_svgD)"
      d="M20.03 7.17q-.26.01-.49.05.56.81.94 1.7.18.4.17.83 0 .39-.14.77a3 3 0 0 1-.43.65q-.27.3-.65.43a2 2 0 0 1-.76.14q-.55 0-1-.29l-.2.77c-.37 1.25-.62 1.7-.62 1.7q-.21.5-.51.97c-.14.2-.31.4-.54.48q-.13.04-.26.03a.5.5 0 0 1-.25-.09 1.4 1.4 0 0 1-.37-.45q-.16-.3-.28-.6c-.18-.42-.46-1.47-.46-1.47l-.28-1.11-.29-1.1-.2-.75A9 9 0 0 0 12.17 7a4.8 4.8 0 0 0-2.33-1.76c-1.08-.4-2.22-.18-2.22-.18A4.8 4.8 0 0 0 4.5 7.22q.3.08.54.23.35.21.57.51c.25.37.34.85.37 1.3q.17 1.49.56 2.93c.6-2.01 1.34-2.95 1.34-2.95a1 1 0 0 1 .28-.26q.09-.04.2-.05c.12 0 .26.02.34.08q.03.01.06.03.13.12.25.28c.15.29.29.54.4.86.23.62.43 1.41.43 1.41l.57 2.28c.42 1.56.76 2.3.76 2.3.88 2.01 2.22 2.58 2.22 2.58.65.34 1.39.54 2.13.57.7.02 1.41-.12 2.04-.43a5.5 5.5 0 0 0 2.58-2.72q.8-1.59 1.22-3.3.3-1.05.46-2.16.1-.53.14-1.07.1-.51-.03-1.03-.03-.07-.05-.17a2 2 0 0 0-.88-.99q-.45-.29-.97-.28"
    />
    <path
      fill="url(#webex_svgE)"
      d="M20.03 7.17q-.26.01-.49.05.56.81.94 1.7.18.4.17.83 0 .39-.14.77a3 3 0 0 1-.43.65q-.27.3-.65.43a2 2 0 0 1-.76.14q-.55 0-1-.29l-.2.77c-.37 1.25-.62 1.7-.62 1.7q-.21.5-.51.97c-.14.2-.31.4-.54.48q-.13.04-.26.03a.5.5 0 0 1-.25-.09 1.4 1.4 0 0 1-.37-.45q-.16-.3-.28-.6c-.18-.42-.46-1.47-.46-1.47l-.28-1.11-.29-1.1-.2-.75A9 9 0 0 0 12.17 7a4.8 4.8 0 0 0-2.33-1.76c-1.08-.4-2.22-.18-2.22-.18A4.8 4.8 0 0 0 4.5 7.22q.3.08.54.23.35.21.57.51c.25.37.34.85.37 1.3q.17 1.49.56 2.93c.6-2.01 1.34-2.95 1.34-2.95a1 1 0 0 1 .28-.26q.09-.04.2-.05c.12 0 .26.02.34.08q.03.01.06.03.13.12.25.28c.15.29.29.54.4.86.23.62.43 1.41.43 1.41l.57 2.28c.42 1.56.76 2.3.76 2.3.88 2.01 2.22 2.58 2.22 2.58.65.34 1.39.54 2.13.57.7.02 1.41-.12 2.04-.43a5.5 5.5 0 0 0 2.58-2.72q.8-1.59 1.22-3.3.3-1.05.46-2.16.1-.53.14-1.07.1-.51-.03-1.03-.03-.07-.05-.17a2 2 0 0 0-.88-.99q-.45-.29-.97-.28"
    />
    <path
      fill="url(#webex_svgF)"
      d="M20.03 7.17q-.26.01-.49.05.56.81.94 1.7.18.4.17.83 0 .39-.14.77a3 3 0 0 1-.43.65q-.27.3-.65.43a2 2 0 0 1-.76.14q-.55 0-1-.29l-.2.77c-.37 1.25-.62 1.7-.62 1.7q-.21.5-.51.97c-.14.2-.31.4-.54.48q-.13.04-.26.03a.5.5 0 0 1-.25-.09 1.4 1.4 0 0 1-.37-.45q-.16-.3-.28-.6c-.18-.42-.46-1.47-.46-1.47l-.28-1.11-.29-1.1-.2-.75A9 9 0 0 0 12.17 7a4.8 4.8 0 0 0-2.33-1.76c-1.08-.4-2.22-.18-2.22-.18A4.8 4.8 0 0 0 4.5 7.22q.3.08.54.23.35.21.57.51c.25.37.34.85.37 1.3q.17 1.49.56 2.93c.6-2.01 1.34-2.95 1.34-2.95a1 1 0 0 1 .28-.26q.09-.04.2-.05c.12 0 .26.02.34.08q.03.01.06.03.13.12.25.28c.15.29.29.54.4.86.23.62.43 1.41.43 1.41l.57 2.28c.42 1.56.76 2.3.76 2.3.88 2.01 2.22 2.58 2.22 2.58.65.34 1.39.54 2.13.57.7.02 1.41-.12 2.04-.43a5.5 5.5 0 0 0 2.58-2.72q.8-1.59 1.22-3.3.3-1.05.46-2.16.1-.53.14-1.07.1-.51-.03-1.03-.03-.07-.05-.17a2 2 0 0 0-.88-.99q-.45-.29-.97-.28"
    />
    <path
      fill="url(#webex_svgG)"
      d="M20.03 7.17q-.26.01-.49.05.56.81.94 1.7.18.4.17.83 0 .39-.14.77a3 3 0 0 1-.43.65q-.27.3-.65.43a2 2 0 0 1-.76.14q-.55 0-1-.29l-.2.77c-.37 1.25-.62 1.7-.62 1.7q-.21.5-.51.97c-.14.2-.31.4-.54.48q-.13.04-.26.03a.5.5 0 0 1-.25-.09 1.4 1.4 0 0 1-.37-.45q-.16-.3-.28-.6c-.18-.42-.46-1.47-.46-1.47l-.28-1.11-.29-1.1-.2-.75A9 9 0 0 0 12.17 7a4.8 4.8 0 0 0-2.33-1.76c-1.08-.4-2.22-.18-2.22-.18A4.8 4.8 0 0 0 4.5 7.22q.3.08.54.23.35.21.57.51c.25.37.34.85.37 1.3q.17 1.49.56 2.93c.6-2.01 1.34-2.95 1.34-2.95a1 1 0 0 1 .28-.26q.09-.04.2-.05c.12 0 .26.02.34.08q.03.01.06.03.13.12.25.28c.15.29.29.54.4.86.23.62.43 1.41.43 1.41l.57 2.28c.42 1.56.76 2.3.76 2.3.88 2.01 2.22 2.58 2.22 2.58.65.34 1.39.54 2.13.57.7.02 1.41-.12 2.04-.43a5.5 5.5 0 0 0 2.58-2.72q.8-1.59 1.22-3.3.3-1.05.46-2.16.1-.53.14-1.07.1-.51-.03-1.03-.03-.07-.05-.17a2 2 0 0 0-.88-.99q-.45-.29-.97-.28"
    />
    <path
      fill="url(#webex_svgH)"
      d="M20.03 7.17q-.26.01-.49.05.56.81.94 1.7.18.4.17.83 0 .39-.14.77a3 3 0 0 1-.43.65q-.27.3-.65.43a2 2 0 0 1-.76.14q-.55 0-1-.29l-.2.77c-.37 1.25-.62 1.7-.62 1.7q-.21.5-.51.97c-.14.2-.31.4-.54.48q-.13.04-.26.03a.5.5 0 0 1-.25-.09 1.4 1.4 0 0 1-.37-.45q-.16-.3-.28-.6c-.18-.42-.46-1.47-.46-1.47l-.28-1.11-.29-1.1-.2-.75A9 9 0 0 0 12.17 7a4.8 4.8 0 0 0-2.33-1.76c-1.08-.4-2.22-.18-2.22-.18A4.8 4.8 0 0 0 4.5 7.22q.3.08.54.23.35.21.57.51c.25.37.34.85.37 1.3q.17 1.49.56 2.93c.6-2.01 1.34-2.95 1.34-2.95a1 1 0 0 1 .28-.26q.09-.04.2-.05c.12 0 .26.02.34.08q.03.01.06.03.13.12.25.28c.15.29.29.54.4.86.23.62.43 1.41.43 1.41l.57 2.28c.42 1.56.76 2.3.76 2.3.88 2.01 2.22 2.58 2.22 2.58.65.34 1.39.54 2.13.57.7.02 1.41-.12 2.04-.43a5.5 5.5 0 0 0 2.58-2.72q.8-1.59 1.22-3.3.3-1.05.46-2.16.1-.53.14-1.07.1-.51-.03-1.03-.03-.07-.05-.17a2 2 0 0 0-.88-.99q-.45-.29-.97-.28"
    />
    <path
      fill="url(#webex_svgI)"
      d="M20.03 7.17q-.26.01-.49.05.56.81.94 1.7.18.4.17.83 0 .39-.14.77a3 3 0 0 1-.43.65q-.27.3-.65.43a2 2 0 0 1-.76.14q-.55 0-1-.29l-.2.77c-.37 1.25-.62 1.7-.62 1.7q-.21.5-.51.97c-.14.2-.31.4-.54.48q-.13.04-.26.03a.5.5 0 0 1-.25-.09 1.4 1.4 0 0 1-.37-.45q-.16-.3-.28-.6c-.18-.42-.46-1.47-.46-1.47l-.28-1.11-.29-1.1-.2-.75A9 9 0 0 0 12.17 7a4.8 4.8 0 0 0-2.33-1.76c-1.08-.4-2.22-.18-2.22-.18A4.8 4.8 0 0 0 4.5 7.22q.3.08.54.23.35.21.57.51c.25.37.34.85.37 1.3q.17 1.49.56 2.93c.6-2.01 1.34-2.95 1.34-2.95a1 1 0 0 1 .28-.26q.09-.04.2-.05c.12 0 .26.02.34.08q.03.01.06.03.13.12.25.28c.15.29.29.54.4.86.23.62.43 1.41.43 1.41l.57 2.28c.42 1.56.76 2.3.76 2.3.88 2.01 2.22 2.58 2.22 2.58.65.34 1.39.54 2.13.57.7.02 1.41-.12 2.04-.43a5.5 5.5 0 0 0 2.58-2.72q.8-1.59 1.22-3.3.3-1.05.46-2.16.1-.53.14-1.07.1-.51-.03-1.03-.03-.07-.05-.17a2 2 0 0 0-.88-.99q-.45-.29-.97-.28"
    />
    <defs>
      <radialGradient
        id="webex_svgb"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(2.0112 7.16467 -5.4446 1.52836 13.42 10.95)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#227B60" />
        <stop offset={0.14} stopColor="#227B60" stopOpacity={0.81} />
        <stop offset={0.58} stopColor="#227B60" stopOpacity={0.23} />
        <stop offset={0.78} stopColor="#227B60" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="webex_svgc"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(-.10101 5.032 -3.82228 -.07673 14.57 10.37)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#227B60" />
        <stop offset={0.25} stopColor="#227B60" stopOpacity={0.7} />
        <stop offset={0.71} stopColor="#227B60" stopOpacity={0.2} />
        <stop offset={0.92} stopColor="#227B60" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="webex_svgd"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(88.6 1.51 12.45)scale(4.69218 3.33168)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#227B60" />
        <stop offset={0.07} stopColor="#227B60" stopOpacity={0.9} />
        <stop offset={0.34} stopColor="#227B60" stopOpacity={0.51} />
        <stop offset={0.59} stopColor="#227B60" stopOpacity={0.23} />
        <stop offset={0.79} stopColor="#227B60" stopOpacity={0.06} />
        <stop offset={0.92} stopColor="#227B60" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="webex_svge"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(88.6 1.72 12.44)scale(3.78897 2.68977)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#227B60" />
        <stop offset={0.36} stopColor="#227B60" stopOpacity={0.63} />
        <stop offset={0.92} stopColor="#227B60" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="webex_svgf"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(88.6 1.66 12.6)scale(3.02208 1.93425)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#20735A" />
        <stop offset={0.15} stopColor="#20745A" stopOpacity={0.93} />
        <stop offset={0.38} stopColor="#21755C" stopOpacity={0.74} />
        <stop offset={0.67} stopColor="#21785D" stopOpacity={0.43} />
        <stop offset={1} stopColor="#227B60" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="webex_svgg"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(23.8 -19.63 40.6)scale(4.85976 3.64695)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#227A61" />
        <stop offset={0.36} stopColor="#227A61" stopOpacity={0.56} />
        <stop offset={0.72} stopColor="#227A61" stopOpacity={0.16} />
        <stop offset={0.9} stopColor="#227A61" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="webex_svgh"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(35.27 1.37 22.4)scale(6.48158 5.92772)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3CD9C3" />
        <stop offset={0.07} stopColor="#3BD7C1" stopOpacity={0.9} />
        <stop offset={0.41} stopColor="#38CEB9" stopOpacity={0.42} />
        <stop offset={0.65} stopColor="#36C8B4" stopOpacity={0.12} />
        <stop offset={0.76} stopColor="#35C6B2" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="webex_svgi"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(35.27 17384.7 -23917.24)scale(1151.74 808.231)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3CD9C3" />
        <stop offset={0.07} stopColor="#3BD7C1" stopOpacity={0.9} />
        <stop offset={0.41} stopColor="#38CEB9" stopOpacity={0.42} />
        <stop offset={0.65} stopColor="#36C8B4" stopOpacity={0.12} />
        <stop offset={0.76} stopColor="#35C6B2" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="webex_svgj"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(100.97 2.62 12.56)scale(5.71753 7.06668)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#237F66" stopOpacity={0.8} />
        <stop offset={0.06} stopColor="#2C8C70" stopOpacity={0.65} />
        <stop offset={0.21} stopColor="#3DA785" stopOpacity={0.37} />
        <stop offset={0.35} stopColor="#4ABA93" stopOpacity={0.17} />
        <stop offset={0.47} stopColor="#51C59C" stopOpacity={0.04} />
        <stop offset={0.56} stopColor="#54C99F" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="webex_svgk"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(4.71924 -5.79048 6.25505 5.09786 12.64 12.69)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#167C8A" />
        <stop offset={0.04} stopColor="#167C8A" stopOpacity={0.93} />
        <stop offset={0.33} stopColor="#177F8D" stopOpacity={0.43} />
        <stop offset={0.54} stopColor="#17818F" stopOpacity={0.12} />
        <stop offset={0.65} stopColor="#178290" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="webex_svgl"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(-31.66 29.45 -14.56)scale(7.28822 5.7573)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.05} stopColor="#177D87" />
        <stop offset={0.11} stopColor="#177E89" stopOpacity={0.8} />
        <stop offset={0.21} stopColor="#177F8B" stopOpacity={0.52} />
        <stop offset={0.32} stopColor="#17818D" stopOpacity={0.29} />
        <stop offset={0.42} stopColor="#17818F" stopOpacity={0.13} />
        <stop offset={0.51} stopColor="#178290" stopOpacity={0.03} />
        <stop offset={0.6} stopColor="#178290" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="webex_svgm"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(-130.54 8.38 4.17)scale(4.34283 3.41973)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.26} stopColor="#177F8A" />
        <stop offset={0.27} stopColor="#177F8A" stopOpacity={0.98} />
        <stop offset={0.38} stopColor="#17808C" stopOpacity={0.68} />
        <stop offset={0.5} stopColor="#17818D" stopOpacity={0.43} />
        <stop offset={0.62} stopColor="#17818F" stopOpacity={0.24} />
        <stop offset={0.74} stopColor="#17828F" stopOpacity={0.11} />
        <stop offset={0.86} stopColor="#178290" stopOpacity={0.03} />
        <stop offset={1} stopColor="#178290" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="webex_svgn"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(-173.11 5.19 7.04)scale(4.073)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#13656E" />
        <stop offset={0.11} stopColor="#13646E" stopOpacity={0.73} />
        <stop offset={0.27} stopColor="#12646E" stopOpacity={0.41} />
        <stop offset={0.42} stopColor="#12636E" stopOpacity={0.18} />
        <stop offset={0.55} stopColor="#12636E" stopOpacity={0.05} />
        <stop offset={0.66} stopColor="#12636E" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="webex_svgo"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(-1.39503 -2.48389 2.08518 -1.1711 9.2 15.35)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.13} stopColor="#146A73" />
        <stop offset={0.24} stopColor="#156F79" stopOpacity={0.79} />
        <stop offset={0.45} stopColor="#167783" stopOpacity={0.45} />
        <stop offset={0.65} stopColor="#167D8A" stopOpacity={0.2} />
        <stop offset={0.82} stopColor="#17818E" stopOpacity={0.05} />
        <stop offset={0.95} stopColor="#178290" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="webex_svgp"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(-55.99 17.2 -1.2)scale(2.67841 2.12171)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#198E9C" />
        <stop offset={0.1} stopColor="#198E9C" stopOpacity={0.87} />
        <stop offset={0.41} stopColor="#198E9C" stopOpacity={0.5} />
        <stop offset={0.67} stopColor="#198E9C" stopOpacity={0.23} />
        <stop offset={0.88} stopColor="#198E9C" stopOpacity={0.06} />
        <stop offset={1} stopColor="#198E9C" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="webex_svgw"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(-1.35307 8.85267 -5.84282 -.89303 17.05 11.7)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1A3D9C" />
        <stop offset={0.4} stopColor="#1A3D9C" stopOpacity={0.42} />
        <stop offset={0.7} stopColor="#1A3D9C" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="webex_svgx"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(-166.45246 1089.0429 -587.20477 -89.75007 5448.29 -14052.1)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1A3D9C" />
        <stop offset={0.4} stopColor="#1A3D9C" stopOpacity={0.42} />
        <stop offset={0.7} stopColor="#1A3D9C" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="webex_svgy"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(98.62 8533.61 -5079.47)scale(1312.06 542.041)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1A3D9C" />
        <stop offset={0.4} stopColor="#1A3D9C" stopOpacity={0.42} />
        <stop offset={0.7} stopColor="#1A3D9C" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="webex_svgz"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(83.09 1.57 14.65)scale(7.82788 5.46191)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1A3D9C" />
        <stop offset={0.16} stopColor="#1A3D9C" stopOpacity={0.69} />
        <stop offset={0.33} stopColor="#1A3D9C" stopOpacity={0.4} />
        <stop offset={0.49} stopColor="#1A3D9C" stopOpacity={0.18} />
        <stop offset={0.61} stopColor="#1A3D9C" stopOpacity={0.05} />
        <stop offset={0.7} stopColor="#1A3D9C" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="webex_svgA"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(1.99297 7.25522 -4.93267 1.35498 17.38 12.52)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#18388F" />
        <stop offset={0.37} stopColor="#193B96" stopOpacity={0.45} />
        <stop offset={0.7} stopColor="#1A3D9C" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="webex_svgB"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(.92614 3.37153 -3.20446 .88025 16.56 14.61)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#18388F" />
        <stop offset={0.09} stopColor="#183992" stopOpacity={0.78} />
        <stop offset={0.22} stopColor="#193B96" stopOpacity={0.5} />
        <stop offset={0.35} stopColor="#193C98" stopOpacity={0.28} />
        <stop offset={0.47} stopColor="#1A3C9A" stopOpacity={0.13} />
        <stop offset={0.59} stopColor="#1A3D9C" stopOpacity={0.03} />
        <stop offset={0.7} stopColor="#1A3D9C" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="webex_svgC"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(.92614 3.37153 -3.20446 .88025 16.65 15.2)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1A3D9C" stopOpacity={0.78} />
        <stop offset={0.24} stopColor="#1A3D9C" stopOpacity={0.45} />
        <stop offset={0.44} stopColor="#1A3D9C" stopOpacity={0.2} />
        <stop offset={0.6} stopColor="#1A3D9C" stopOpacity={0.05} />
        <stop offset={0.7} stopColor="#1A3D9C" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="webex_svgD"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(67.03 -5.66 12.61)scale(8.34766 5.53859)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1A3D9C" />
        <stop offset={0.4} stopColor="#1A3D9C" stopOpacity={0.56} />
        <stop offset={0.48} stopColor="#1A3D9C" stopOpacity={0.43} />
        <stop offset={0.69} stopColor="#1A3D9C" stopOpacity={0.12} />
        <stop offset={0.79} stopColor="#1A3D9C" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="webex_svgE"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(1.48746 6.01054 -3.96751 .98186 7.59 11.16)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1A3D9C" />
        <stop offset={0.06} stopColor="#1A3D9C" stopOpacity={0.88} />
        <stop offset={0.21} stopColor="#1A3D9C" stopOpacity={0.61} />
        <stop offset={0.36} stopColor="#1A3D9C" stopOpacity={0.39} />
        <stop offset={0.51} stopColor="#1A3D9C" stopOpacity={0.22} />
        <stop offset={0.67} stopColor="#1A3D9C" stopOpacity={0.1} />
        <stop offset={0.83} stopColor="#1A3D9C" stopOpacity={0.02} />
        <stop offset={1} stopColor="#1A3D9C" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="webex_svgF"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(1.48746 6.01054 -3.96751 .98186 7.59 11.16)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1B3E9E" />
        <stop offset={0.06} stopColor="#1B3E9E" stopOpacity={0.87} />
        <stop offset={0.21} stopColor="#1B3E9D" stopOpacity={0.61} />
        <stop offset={0.36} stopColor="#1A3D9D" stopOpacity={0.39} />
        <stop offset={0.52} stopColor="#1A3D9C" stopOpacity={0.22} />
        <stop offset={0.67} stopColor="#1A3D9C" stopOpacity={0.1} />
        <stop offset={0.83} stopColor="#1A3D9C" stopOpacity={0.02} />
        <stop offset={1} stopColor="#1A3D9C" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="webex_svgG"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(76.1 -2.86 10.22)scale(4.73763 3.12718)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#183991" />
        <stop offset={0.03} stopColor="#183992" stopOpacity={0.95} />
        <stop offset={0.18} stopColor="#193A95" stopOpacity={0.66} />
        <stop offset={0.34} stopColor="#193B97" stopOpacity={0.42} />
        <stop offset={0.5} stopColor="#1A3C99" stopOpacity={0.24} />
        <stop offset={0.66} stopColor="#1A3D9B" stopOpacity={0.1} />
        <stop offset={0.82} stopColor="#1A3D9C" stopOpacity={0.03} />
        <stop offset={1} stopColor="#1A3D9C" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="webex_svgH"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(87.14 -1.45 10.02)scale(3.74352 3.29475)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.04} stopColor="#2453D6" stopOpacity={0.6} />
        <stop offset={0.2} stopColor="#2453D6" stopOpacity={0.49} />
        <stop offset={0.52} stopColor="#2453D6" stopOpacity={0.2} />
        <stop offset={0.73} stopColor="#2453D6" stopOpacity={0} />
      </radialGradient>
      <linearGradient
        id="webex_svga"
        x1={2.91}
        x2={18.47}
        y1={14.7}
        y2={8.41}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.13} stopColor="#1CBBF3" />
        <stop offset={0.34} stopColor="#1F99A5" />
        <stop offset={0.45} stopColor="#209CA6" />
        <stop offset={0.51} stopColor="#24A4AA" />
        <stop offset={0.57} stopColor="#2BB3B0" />
        <stop offset={0.6} stopColor="#30BDB4" />
        <stop offset={0.79} stopColor="#38BA90" />
        <stop offset={1} stopColor="#60F05A" />
      </linearGradient>
      <linearGradient
        id="webex_svgq"
        x1={3.9}
        x2={10.76}
        y1={4.69}
        y2={11.04}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.13} stopColor="#2BF9FF" />
        <stop offset={0.27} stopColor="#29F9FF" stopOpacity={0.64} />
        <stop offset={0.4} stopColor="#27FAFF" stopOpacity={0.3} />
        <stop offset={0.49} stopColor="#26FAFF" stopOpacity={0.08} />
        <stop offset={0.54} stopColor="#26FAFF" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="webex_svgr"
        x1={0.02}
        x2={8.04}
        y1={15.07}
        y2={12.79}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#26FAFF" />
        <stop offset={0.06} stopColor="#26FAFF" stopOpacity={0.88} />
        <stop offset={0.24} stopColor="#26FAFF" stopOpacity={0.51} />
        <stop offset={0.39} stopColor="#26FAFF" stopOpacity={0.23} />
        <stop offset={0.5} stopColor="#26FAFF" stopOpacity={0.06} />
        <stop offset={0.55} stopColor="#26FAFF" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="webex_svgs"
        x1={2.14}
        x2={11.18}
        y1={14.79}
        y2={11.57}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#21DEFF" />
        <stop offset={0.04} stopColor="#21DEFF" stopOpacity={0.88} />
        <stop offset={0.17} stopColor="#21DEFF" stopOpacity={0.51} />
        <stop offset={0.27} stopColor="#21DEFF" stopOpacity={0.23} />
        <stop offset={0.34} stopColor="#21DEFF" stopOpacity={0.06} />
        <stop offset={0.38} stopColor="#21DEFF" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="webex_svgt"
        x1={10.73}
        x2={15.79}
        y1={10.11}
        y2={18.36}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.62} stopColor="#21DEFF" stopOpacity={0} />
        <stop offset={0.66} stopColor="#21DEFF" stopOpacity={0.06} />
        <stop offset={0.73} stopColor="#21DEFF" stopOpacity={0.23} />
        <stop offset={0.83} stopColor="#21DEFF" stopOpacity={0.51} />
        <stop offset={0.96} stopColor="#21DEFF" stopOpacity={0.88} />
        <stop offset={1} stopColor="#21DEFF" />
      </linearGradient>
      <linearGradient
        id="webex_svgu"
        x1={16.36}
        x2={15.56}
        y1={13.19}
        y2={9.31}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#44B044" />
        <stop offset={0.11} stopColor="#44B044" stopOpacity={0.8} />
        <stop offset={0.27} stopColor="#44B044" stopOpacity={0.52} />
        <stop offset={0.43} stopColor="#44B044" stopOpacity={0.29} />
        <stop offset={0.58} stopColor="#44B044" stopOpacity={0.13} />
        <stop offset={0.7} stopColor="#44B044" stopOpacity={0.03} />
        <stop offset={0.8} stopColor="#44B044" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="webex_svgv"
        x1={5.27}
        x2={22}
        y1={9.15}
        y2={14.7}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3066FB" />
        <stop offset={0.38} stopColor="#2F64F7" />
        <stop offset={0.74} stopColor="#2857D9" />
        <stop offset={1} stopColor="#3C7EFF" />
      </linearGradient>
      <linearGradient
        id="webex_svgI"
        x1={16.14}
        x2={11.91}
        y1={2.34}
        y2={12.79}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3774FF" />
        <stop offset={0.05} stopColor="#3774FF" stopOpacity={0.91} />
        <stop offset={0.16} stopColor="#3774FF" stopOpacity={0.66} />
        <stop offset={0.32} stopColor="#3774FF" stopOpacity={0.28} />
        <stop offset={0.43} stopColor="#3774FF" stopOpacity={0} />
      </linearGradient>
    </defs>
  </svg>,
  "Webex",
);
export default WebexIcon;
